module.exports = __webpack_public_path__ + "static/media/dine-in-brown.ca8cce92.svg";